import { render, staticRenderFns } from "./OrderUpsert.vue?vue&type=template&id=5e4f14e4&"
import script from "./OrderUpsert.vue?vue&type=script&lang=js&"
export * from "./OrderUpsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports